import { render, staticRenderFns } from "./PeviewPDF.vue?vue&type=template&id=6b4a00bb&scoped=true&"
import script from "./PeviewPDF.vue?vue&type=script&lang=js&"
export * from "./PeviewPDF.vue?vue&type=script&lang=js&"
import style0 from "./PeviewPDF.vue?vue&type=style&index=0&id=6b4a00bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a00bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
